import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import * as Sentry from '@sentry/react'
import './styles.css'
import App from './App.tsx'
import ErrorFallback from './components/ErrorFallback.tsx'

if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT ?? 'development',
    tracesSampleRate: 0,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,
  })
  // Small helper for manual prod verification from the browser console:
  //   __sentryTest("my message")
  // Only exposes a single-purpose function so tree-shaking stays effective.
  ;(window as unknown as { __sentryTest: (msg?: string) => string }).__sentryTest = (
    msg = 'manual test from console',
  ) => Sentry.captureException(new Error(msg))
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={<ErrorFallback />}>
      <App />
    </Sentry.ErrorBoundary>
  </StrictMode>,
)
